import ServiceDashboard from '../../src/views/service/ServiceDashboardSingle.vue'
import ServiceDashboardContainer from '../../src/views/service/ServiceDashboardContainer.vue'
import ServiceDatatable from '../../src/views/service/ServiceDatatable.vue'
import ServicePageSvg from '../../src/views/service/ServicePageSvgSingle.vue'
import ServicePageSvgForMC from '../../src/views/service/ServicePageSvg.vue'
import ServiceSvgTabs from '../../src/views/service/ServiceSvgTabs.vue'
import ServiceModelViewer from '../../src/views/public/3DViewerCUSTOM.vue'

import JModalContentCOIItem from '../../src/components/JModalContentCOIItem.vue'
import JCommentsBoard from '../../src/components/JCommentsBoard.vue'

export default {
  ServiceDashboard,
  ServiceDashboardContainer,
  ServiceDatatable,
  ServicePageSvg,
  ServicePageSvgForMC,
  ServiceSvgTabs,
  ServiceModelViewer,

  JModalContentCOIItem,
  JCommentsBoard,
}
